import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[sixDigitAfterAndBeforeDecimalNumber]',
    standalone: true
})
export class SixDigitAfterAndBeforeDecimalNumberDirective {
    // Allow decimal numbers and negative values
    private regex: RegExp = new RegExp(/^\d{1,6}(\.$|\.\d{1,6}$|$)/);
    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

    constructor(private el: ElementRef) {
    }

    private getInputElement(): HTMLInputElement {
        const native = this.el.nativeElement;
        return native.tagName === 'INPUT' ? native : native.querySelector('input');
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const inputEl = this.getInputElement();
        if (!inputEl) return;
        let current: string = inputEl.value;
        const position = inputEl.selectionStart;
        const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
}